// @flow
import { path } from 'ramda'

import { getMoviesLanguages } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_MOVIE_LANGUAGES_TYPE = 'movies_languages/FETCH_LANGUAGE'

const fetchMovieLanguagesAction = (servicespec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_MOVIE_LANGUAGES_TYPE,
    payload: getMoviesLanguages(publicApi, servicespec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchMovieLanguages = (servicespec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchMovieLanguagesAction(servicespec))

  const state = getState()
  const expires = path(['movieLanguages', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchMovieLanguagesAction(servicespec))
}
